import { Helmet } from 'react-helmet-async';
import React from 'react';
import ProjectFilesContainer from '../../containers/projects/ProjectFilesContainer.jsx';
import requireAuth from '../../lib/requireAuth.jsx';
import withRouterParams from '../../lib/withRouterParams.jsx';

const ProjectFiles = ({ projectId }) => (
  <>
    <Helmet>
      <title>Files | ChangeSync</title>
    </Helmet>
    <ProjectFilesContainer projectId={projectId} />
  </>
);

ProjectFiles.getInitialProps = ({ query }) => ({
  projectId: Number(query.projectId),
});

export default requireAuth(withRouterParams(ProjectFiles));
